import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import './Button.css';

// eslint-disable-next-line react-refresh/only-export-components
export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  PrimaryTertiary = 'primaryTertiary',
  PrimaryLink = 'primaryLink',
  PrimaryDanger = 'primaryDanger',
  SecondaryDanger = 'secondaryDanger',
  DangerLink = 'dangerLink',
}

type ButtonProps = {
  type?: ButtonType;
  htmlType?: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  fill?: boolean;
  loading?: boolean;
  loadingText?: string;
  ariaLabel?: string;
};

function Button({
  children,
  onClick,
  type = ButtonType.Primary,
  htmlType = 'button',
  className,
  disabled,
  fill,
  loading = false,
  loadingText,
  ariaLabel,
}: ButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      type={htmlType}
      onClick={onClick}
      className={`${type.toString()} button ${className} ${fill ? 'fill' : ''}`}
      aria-label={ariaLabel}
      aria-busy={loading}
      disabled={isDisabled}
    >
      {loading ? (
        <>
          <LoadingSpinner className="button-spinner" />
          {loadingText || children}
        </>
      ) : (
        children
      )}
    </button>
  );
}

export default Button;
